import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Typography } from "antd";

const { Title } = Typography;

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="w-screen h-screen text-center mt-20">
      <Title>Page Not Found</Title>
      <div
        onClick={() => navigate(-1)}
        className="cursor-pointer underline text-xl text-light-blue"
      >
        Go back
      </div>
    </div>
  );
};

export default PageNotFound;
